import * as constants from '../constants';

const initialState = [];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getVegetationPhases.success: {
            return action.payload.results;
        }

        case constants.getVegetationPhases.error: {
            return initialState;
        }

        default:
            return state;
    }
}
